import { IconSvg } from 'monica-alexandria';
import styled from 'styled-components';

const StepsProgress = styled.div`
    display: flex;
    align-items: center;
    height: 2rem;
`;

const StepsProgressBar = styled.div`
    position: relative;
    width: 100%;
    height: 0.5rem;
    overflow: hidden;
    border-radius: var(--smallRadius);
    background: ${p => p.theme.high};
`;

const StepsProgressBarInner = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${p => `${p.progressPercent}%`};
    background: var(--main);
    transition: width 0.2s;
`;

const StepsProgressCompletion = styled.div`
    height: 2rem;
    width: 2rem;
    padding: 0.5rem;
    border-radius: 50%;
    background: var(--main);

    svg {
        width: 100%;
        fill: ${p => p.theme.background};
    }
`;

export const Steps_Progress = (props) => {
    const progressPercent = (props.currentStep / props.totalSteps) * 100;
    let finalProgressPercent = progressPercent;

    if (props.review) {
        finalProgressPercent = 100;
    }

    let showCompletion = false;

    if (props.currentStep >= props.totalSteps) {
        showCompletion = true;
    }

    if (props.review) {
        showCompletion = true;
    }

    return (
        <StepsProgress>
            <StepsProgressBar>
                <StepsProgressBarInner progressPercent={finalProgressPercent} />
            </StepsProgressBar>
            {showCompletion ? (
                <StepsProgressCompletion>
                    <IconSvg Icon="Check" />
                </StepsProgressCompletion>
            ) : null}
        </StepsProgress>
    );
};
